
<div style="float: left; padding-top: 8px;">{{ data.message | translate }} @if (data.params) {
  {{data.params}}
}</div>
<button (click)="closeMessage()" style="float: right;" mat-icon-button>
  <mat-icon>
    close
  </mat-icon>
</button>
